import React from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import './LegalPage.css';

const TermsPage = () => (
  <main className="legal-page">
    <PageTitle title="Terms" />
    <section className="legal-hero">
      <Link className="legal-back-link" to="/">
        <i className="bi bi-arrow-left" aria-hidden="true" /> Home
      </Link>
      <span className="legal-icon">
        <i className="bi bi-file-text" aria-hidden="true" />
      </span>
      <div className="legal-eyebrow">Terms</div>
      <h1>Terms for using MarkazSync responsibly.</h1>
      <p>
        MarkazSync is intended for authorized school staff managing real markaz operations. By
        using the app, staff should follow their school policies and handle student and parent
        information with care.
      </p>
      <p className="legal-updated">Last updated: September 4, 2026</p>
    </section>

    <section className="legal-content">
      <article>
        <h2>Authorized use</h2>
        <p>
          Accounts should only be used by the assigned staff member. Do not share passwords, access
          records for unrelated purposes, or use the system outside your school responsibilities.
        </p>
      </article>
      <article>
        <h2>School responsibility</h2>
        <p>
          Each school or markaz is responsible for deciding what information it enters into
          MarkazSync, making sure it has permission to collect and use that information, and
          training staff to follow school policies and applicable requirements.
        </p>
      </article>
      <article>
        <h2>Accurate records</h2>
        <p>
          Staff are responsible for entering accurate attendance, parent, student, class, form, and
          financial information. Review reports before sharing or making decisions from them.
        </p>
      </article>
      <article>
        <h2>Email communications</h2>
        <p>
          MarkazSync may send email related to account setup, password resets, contact-form replies,
          support, and backups when enabled by the school. Users should provide accurate email
          addresses and should not use account notices for unrelated purposes.
        </p>
      </article>
      <article>
        <h2>Documents and reports</h2>
        <p>
          Uploaded files, printed documents, exported reports, and financial records should be used
          according to your markaz policies. Do not upload files that your school is not permitted
          to store.
        </p>
      </article>
      <article>
        <h2>Account security</h2>
        <p>
          Keep login details private, sign out on shared devices, and report access issues to the
          school administrator. Role-based access helps protect the app, but staff behavior remains
          important.
        </p>
      </article>
      <article>
        <h2>Acceptable behavior</h2>
        <p>
          Do not misuse the app, attempt to bypass access controls, interfere with the service,
          upload malicious files, or enter false information intentionally.
        </p>
      </article>
      <article>
        <h2>Service changes</h2>
        <p>
          Features may change as the app is improved or as school needs change. MarkazSync may also
          limit or suspend access when needed to protect the service, investigate misuse, perform
          maintenance, or address security concerns.
        </p>
      </article>
      <article>
        <h2>Availability and backups</h2>
        <p>
          MarkazSync is provided for operational support, but uninterrupted access is not guaranteed.
          Schools should keep appropriate copies of important reports, receipts, and records and
          verify backups according to their own retention needs.
        </p>
      </article>
      <article>
        <h2>No professional advice</h2>
        <p>
          Financial, attendance, and administrative reports are generated from data entered by users.
          The app does not provide legal, tax, accounting, educational, or compliance advice.
        </p>
      </article>
      <article>
        <h2>Ending use</h2>
        <p>
          A school may stop using MarkazSync by coordinating account access, exports, and record
          removal with its administrator or support contact. Staff should not retain exported
          student, parent, or financial information after their school no longer authorizes it.
        </p>
      </article>
      <article>
        <h2>Contact</h2>
        <p>
          Questions about account access, records, or school policies should first go to the school
          administrator. General MarkazSync support requests can be sent through the contact page.
        </p>
      </article>
    </section>
  </main>
);

export default TermsPage;
